<script>
    import ProductNavigation from "@/components/product/ProductNavigation";
    import ProductTypography from "@/components/product/ProductTypography";
    import ProductReviews from "@/components/product/ProductReviews";

    export default {
        name: "ProductBody",
        components: { ProductReviews, ProductTypography, ProductNavigation },
        props: {
            product: Object,
            listForHeader: Array,
            videoList: Array,
            reviews: {
                type: Object,
                default: () => {},
            },
            isArrow: {
                type: Boolean,
                default: true,
            },
            topMargin: {
                type: Number,
                default: 130,
            },
            mobileActiveTab: String,
            parametersTitle: {
                type: String,
                default: "Технические данные",
            },
            equipmentsTitle: {
                type: String,
                default: "Что в коробке",
            },
        },
        data() {
            return {
                selectedMobileTab: "description",
            };
        },
        watch: {
            mobileActiveTab: {
                handler(updatedTab) {
                    this.selectedMobileTab = updatedTab;
                },
            },
        },
    };
</script>

<template>
    <div class="product__body">
        <slot name="beforeNavigation"></slot>

        <div class="product__navigation">
            <product-navigation
                :product="product"
                :list-anchor="listForHeader"
                :selected-tab="selectedMobileTab"
                @on-change="selectedMobileTab = $event"
            ></product-navigation>
        </div>

        <div class="product__body-content">
            <slot name="before"></slot>

            <product-typography
                :product="product"
                :video-list="videoList"
                :selected="selectedMobileTab"
                :parameters-title="parametersTitle"
                :equipments-title="equipmentsTitle"
            ></product-typography>
            <div class="product-anchor-style js-anchor-reviews"></div>
            <div
                v-if="reviews.total > 0"
                id="reviews"
                class="product__reviews"
                :class="{ visible: this.selectedMobileTab === 'reviews' }"
            >
                <product-reviews
                    :reviews="reviews"
                    :product="product"
                    :is-arrow="isArrow"
                ></product-reviews>
            </div>
        </div>

        <div class="product__body-aside" :style="{ top: topMargin + 'px' }">
            <slot name="gift"></slot>
            <div v-if="$slots.relatedSlider" class="product__related-list" id="related">
                <slot name="relatedSlider"></slot>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .product__body {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        margin-top: 40px;

        @include bp($bp-desktop-sm) {
            position: relative;
            flex-direction: row;
        }
        // xd
        //display: flex;
        //flex-direction: column-reverse;
        //margin-bottom: 40px;
        //
        //@include bp($bp-desktop-sm) {
        //    flex-direction: row;
        //    margin-bottom: 56px;
        //}
    }

    .product__body-aside {
        width: 100%;
        max-width: 100%;
        .product-cards-slider {
            margin-bottom: 0;
        }
        @include bp($bp-desktop-sm) {
            @include sticky();
            max-width: 448px;
            .product-cards-slider {
                margin-bottom: 40px;
            }
        }
    }

    .product__body-content {
        max-width: 100%;
        @include bp($bp-desktop-sm) {
            width: calc(100% - 448px);
            padding-right: 44px;
        }
    }

    .product__navigation {
        margin-bottom: 24px;
        min-width: 100%;
        width: 100%;
        @include bp($bp-desktop-sm) {
            display: none;
        }
    }

    .product__reviews {
        display: none;
        margin-bottom: 32px;
        &.visible {
            display: block;
        }

        @include bp($bp-desktop-sm) {
            display: block;
            margin-bottom: 0;
            padding-top: 40px;
        }
    }
</style>
